<div class="c-alert-box o-media o-media--small"
  [ngClass]="'c-alert-box--' + size">

  @if (!!icon) {
    <div class="o-media__img">
      <fa-icon class="c-alert-box__icon"
        [icon]="icon"
        [fixedWidth]="true">
      </fa-icon>
    </div>
  }

  <div class="o-media__body">
    @if (title) {
      <h4 class="c-alert-box__title" [innerText]="title"></h4>
    }

    @if (body) {
      <div [innerHTML]="body | safe:'html'"></div>
    }
  </div>
</div>
